import authApi from 'api/authApi';
import { updateAxiosAccessToken } from 'api/axiosClient';
import maintainerApi from 'api/maintainerApi';
import AppConstants from 'general/constants/AppConstants';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import ToastHelper from 'general/helpers/ToastHelper';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// ---- thunks ----
// dang nhap admin/agency
export const thunkLogIn = createAsyncThunk('auth/thunkLogIn', async (params, thunkAPI) => {
  try {
    const res = await authApi.signIn(params);
    return res;
  } catch (error) {
    return {
      result: 'failed',
      reason: error?.response?.data?.reason ?? 'Đăng nhập không thành công',
    };
  }
});

// dang nhap maintainer
export const thunkLogInMaintainer = createAsyncThunk('auth/thunkLogInMaintainer', async (params, thunkAPI) => {
  try {
    const res = await maintainerApi.signIn(params);
    return res;
  } catch (error) {
    return {
      result: 'failed',
      reason: error?.response?.data?.reason ?? 'Đăng nhập không thành công',
    };
  }
});

// ---- params ----
const initialState = {
  isLoggingIn: false,
  user: {},
  agencyRoleList: [],
  permissionList: [],
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetAuthSlice: (state, action) => {
      return initialState;
    },
    updateUser: (state, action) => {
      state.user = action.payload ?? {};
    },
    setAgencyRoleList: (state, action) => {
      state.agencyRoleList = action.payload ?? '';
    },
    setPermissionList: (state, action) => {
      state.permissionList = action.payload ?? '';
    },
  },
  extraReducers: {
    // dang nhap admin/agency
    [thunkLogIn.pending]: (state, action) => {
      state.isLoggingIn = true;
    },
    [thunkLogIn.rejected]: (state, action) => {
      state.isLoggingIn = false;
    },
    [thunkLogIn.fulfilled]: (state, action) => {
      state.isLoggingIn = false;
      const { result, user, reason } = action.payload;
      if (result == 'success') {
        let token = user?.token;
        localStorage.setItem(PreferenceKeys.accessToken, token);
        localStorage.setItem(PreferenceKeys.savedLoginEmail, user?.email);
        localStorage.setItem(PreferenceKeys.savedActiveRole, user?.role);
        updateAxiosAccessToken(token);
        state.user = user ?? {};
        if (user?.role === AppConstants.userRole.agency && !_.isUndefined(user.agency)) {
          if (user.agency?.primaryRole !== 'VOUCHER_PARTNER') {
            const agencyRoleList = [
              ...new Set(
                user?.agency?.commissions?.map((commission) => ({
                  role: commission.role,
                  commissionId: commission.commissionId
                })) || []
              )
            ];

            agencyRoleList.sort((a, b) => a.commissionId - b.commissionId);

            let formatAgencyRoleList = [...new Set(agencyRoleList.map(item => item.role))];
            // Fallback: account khong co commissions (vd tong dai ly SALE) van phai
            // co role tu primaryRole, tranh menu rong -> man hinh xanh "khong co quyen".
            if (formatAgencyRoleList.length === 0 && user.agency?.primaryRole) {
              formatAgencyRoleList = [user.agency.primaryRole];
            }
            state.agencyRoleList = formatAgencyRoleList;
          } else {
            state.agencyRoleList = ['VOUCHER_PARTNER']
          }
        }

        const permissionList = user?.permissionGroup?.permissions?.map((permission) => {
          return { path: permission.fe_path, code: permission.code };
        })
        state.permissionList = permissionList;
      } else {
        ToastHelper.showError(reason);
      }
    },

    // dang nhap maintainer
    [thunkLogInMaintainer.pending]: (state, action) => {
      state.isLoggingIn = true;
    },
    [thunkLogInMaintainer.rejected]: (state, action) => {
      state.isLoggingIn = false;
    },
    [thunkLogInMaintainer.fulfilled]: (state, action) => {
      state.isLoggingIn = false;
      const { result, user, reason } = action.payload;
      if (result == 'success') {
        let token = user?.token;
        localStorage.setItem(PreferenceKeys.accessToken, token);
        localStorage.setItem(PreferenceKeys.savedLoginEmail, user?.email);
        localStorage.setItem(PreferenceKeys.savedActiveRole, user?.role);
        updateAxiosAccessToken(token);
        state.user = user ?? {};

        const permissionList = user?.permissionGroup?.permissions?.map((permission) => {
          return { path: permission.fe_path, code: permission.code };
        })
        state.permissionList = permissionList;
      } else {
        ToastHelper.showError(reason);
      }
    },
  },
});

const { reducer, actions } = authSlice;
export const { resetAuthSlice, updateUser, setAgencyRoleList, setPermissionList } = actions;
export default reducer;
